import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import Button from "../elements/Buttons";
import TextBox from "../elements/TextBox";
import ExtraButtons from "./ExtraButtons";
import { RefreshBotSvg } from "../utils/svg-icons-24";

const UserInputArea = ({
  disableElement,
  isMic,
  refreshAction,
  language,
  micAction,
  value,
  handleChange,
  handleOtpChange,
  handleKeydown,
  handleNationalIdChange,
  handleNationalIdKeydown,
  handleUDSNumChange,
  handleReqNumChange,
  inputType,
  btnActions,
  isMainMenu,
  messageLists,
  isLanguageBtn,
  languageAction,
  isServiceBusy
}) => {

  useEffect(() => {
    //console.log(disableElement);
  }, [disableElement]);

  let infotext = language === 'ar'
    ? "يعمل طاقمنا حاليًا على تحديث وتطوير الكهرباء بوت بمرحلة الاطلاق التجريبي، حرصًا على تقديم أفضل التجارب والخدمات لك."
    : "Our team is working on updating and developing the AL KAHRABA Bot in the beta launch, to provide you with the best experiences and services.";

  return (
    <>
      <div className="input-group " id="inputArea">
        <div className="drag-active-wrapper">
          <Button
            id="ref"
            type="button"
            classes="material-icons emoji-switch"
            title={language === 'ar'? "تحديث": "Refresh"}
            action={refreshAction}
            areaLabel={language === 'ar'? "تحديث": "Refresh"}
            svg="true"
            disabled={disableElement.refreshBtn}
          >
            <RefreshBotSvg id={'ic_emojiSwitch'} />
          </Button>

          <TextBox
            type='text'
            disabled={disableElement.textBx}
            autocomplete='off'
            id={inputType}
            name='usertext'
            placeholder={language}
            className=''
            handleChange={handleChange}
            handleOtpChange={handleOtpChange}
            handleKeydown={handleKeydown}
            handleNationalIdChange={handleNationalIdChange}
            handleNationalIdKeydown={handleNationalIdKeydown}
            value={value}
          />

          {isMic && (
            <Button
              id="mic-switch"
              type="button"
              classes="material-icons mic-btn"
              title="Mic"
              action={micAction}
              areaLabel="Mic"
              svg="true"
              disabled={disableElement.sendBtn}
            >
              <i className="material-icons type1 for-closed color-white">
                <svg id="ic_mic_on" fill="#000000" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
                </svg>
                <svg id="ic_mic_off" fill="#000000" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none" />
                  <path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z" />
                </svg>
                <svg id="ic_mic_working" fill="#000000" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z" />
                </svg>
              </i>
            </Button>
          )}
        </div>
      </div>
      <ExtraButtons
          actionHistory={btnActions}
          actionMenu={() => {
            // console.log("Menu click");
          }}
          language={language}
          disableBack={isMainMenu}
          messageCount = {messageLists.length}
          isLanguageBtn={isLanguageBtn}
          languageAction={languageAction}
          isServiceBusy={isServiceBusy}
      />
    </>
  );
};

export default UserInputArea;
